import {BaseRepository} from "@/modern/core/repositories/BaseRepository";
import {AgendaEncontroFiltros, ContentModel, MotivoFaltaModel, ServiceTypesModel} from "@/modern/core";

export class ConfigRepository extends BaseRepository {

    async getServiceTypesQuery() {
        const request = await this.httpClient.get(this.baseUrl.generateURL('tipos-atedimentos'))
        return this.handleMultipleRequest<ServiceTypesModel>(request);
    }

    async getContentListQuery(id: string | number) {
        const request = await this.httpClient.get(
            this.baseUrl.generateURL(`atividades/${id}/conteudos`)
        );
        return this.handleMultipleRequest<ContentModel>(request)
    }

    async getMotivosFaltasQuery() {
        const request = await this.httpClient.get(this.baseUrl.generateURL('motivos-falta/encontros'))
        return this.handleMultipleRequest<MotivoFaltaModel>(request);
    }

    async getEncontrosFiltrosQuery(
        startDate: string,
        endDate: string,
        projetoId?: string | number,
        grupoId?: string | number,
        atividadeId?: string | number
    ) {
        this.baseUrl.addSegment('encontro/filtros');

        this.baseUrl.addQuery({
            data_inicial: startDate,
            data_final: endDate,
            projeto_id: projetoId,
            grupo_id: grupoId,
            atividade_id: atividadeId
        });

        const request = await this.httpClient.get(this.baseUrl.generateURL());

        return this.handleSingleRequest<AgendaEncontroFiltros>(request);
    }
}